import type { AppProductFamily, AppProductGroup, AppProductVariant } from '#types/AppTypes'

export const getHierarchyPaths = (options: AppProductVariant | AppProductFamily) => {
  const paths: string[] = []
  let current: AppProductFamily | AppProductGroup | undefined = 'parentFamily' in options ? options.parentFamily : options.parentGroup

  while (current) {
    paths.unshift(current.path)
    current = current.parentGroup
  }
  return paths
}
